exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".explanation-icon i{font-size:18px;margin-left:2px;top:2px;position:relative}.tooltip{display:block!important;padding:4px;z-index:10000}.tooltip .tooltip-inner{background:#fff;border:1px solid #ddd;color:#000;border-radius:16px;padding:5px 10px 4px}.tooltip .tooltip-arrow{display:none}.tooltip[aria-hidden=true]{visibility:hidden;opacity:0;transition:opacity .15s,visibility .15s}.tooltip[aria-hidden=false]{visibility:visible;opacity:1;transition:opacity .15s}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-104ea8ea","scoped":false,"hasInlineConfig":true}!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/general/IconTooltip.vue
// module id = KA7j
// module chunks = 0 1